import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

/**
 * Footer component that projects content in the drawer
 */
@Component({
  selector: 'siat-drawer-footer',
   
  imports: [CommonModule],
  template: `
    <div class="drawer-footer justify-end space-x-4 p-4">
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      .drawer-footer {
        display: flex;
      }
    `,
  ],
})
export class DrawerFooterComponent {}
